<template lang="pug">
  .advance-settings
    v-container.px-0(style="max-width:600px")
      v-card.py-4.mt-4(flat outlined)
        div.px-4.pb-4
          div.s1.basic800--text {{ $t('section_title_zone') }}
          div.c1.basic600--text {{ $t('section_desc_zone') }}
          a.c1.accent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/articles/900003730746-How-To-Setup-Manual-Delivery" target="_blank") {{ $t('learn_more') }}
        delivery-zone-list(:open.sync="openManageDeliveryZoneDialog" :company="company" :couriers="couriers")            

    .modals
      update-trackers(v-if="showUpdateTrackersDialog" :open.sync="showUpdateTrackersDialog" :company.sync="company" :type="openTrackerType")
      update-webhook(v-if="showUpdateWebhookDialog" :open.sync="showUpdateWebhookDialog" :company="company")
      request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
      domain-verifications(v-if="openDomainVerifications" :open.sync="openDomainVerifications" :company="company")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateTrackers from '@/components/dialogs/settings/UpdateTrackers.vue'
import UpdateWebhook from '@/components/dialogs/settings/UpdateWebhook.vue'
import RequestCustomDomain from '@/components/dialogs/RequestCustomDomain.vue'
import DomainVerifications from '@/components/dialogs/DomainVerifications.vue'
import OnlinePaymentList from '@/components/settings/OnlinePaymentList.vue'
import DeliveryChargeList from '@/components/dialogs/settings/DeliveryChargeList.vue'
import DeliveryZoneList from '@/components/dialogs/settings/DeliveryZoneList.vue'

export default {
  name: 'AdvanceConfigurationSettings',
  components: { UpdateTrackers, UpdateWebhook, RequestCustomDomain, DomainVerifications, OnlinePaymentList, DeliveryChargeList, DeliveryZoneList },
  props: ['company'],
  data () {
    return {
      paymentExpansionPanels: undefined,
      showUpdateTrackersDialog: false,
      showUpdateWebhookDialog: false,
      openRequestCustDomain: false,
      openDomainVerifications: false,
      openTrackerType: '',
      ecommerce: [
        { title: 'WooCommerce', image: require('@/assets/images/settings/logo_woocommerce.svg'), link: '/admin/settings/woocommerce', action: 'router-push' },
        // { title: 'Magento', image: require('@/assets/images/magento-logo-square.png'), link: '/admin/settings/woocommerce', action: 'dialog' },
        { title: 'Shopify', image: require('@/assets/images/settings/logo_shopify.svg'), link: '/admin/settings/shopify', action: 'router-push' },
      ],
      openManageDeliveryZoneDialog: false,
      couriers: []
    }
  },
  mounted () {
    this.fetchShippingSettings()
    this.handleClickFromYezzaPayNoticeBanner()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink (link) {
      if (link === 'w') {
        window.open('https://guide.yezza.io/eng/tips-use-webhook/')
      } else if (link === 'a' ) {
        window.open('https://help.yezza.io/hc/en-my/sections/900000600066-Analytics')
      } else if (link === 'p' ) {
        window.open('https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments')
      } else {
        window.open('https://help.yezza.io/hc/en-my/articles/900003297906-How-To-Integrate-Yezza-With-WooCommerce-')
      }
    },
    setUp (path) {
      if (!this.Auth('root', 'e_commerce_integrations')) {
        this.showMessage(['upgrade'])
        return
      }
      this.$router.push(path)
    },
    openTrackerDialog (type) {
      this.openTrackerType = type
      this.showUpdateTrackersDialog = true
    },
    openWebhookDialog () {
      //this.openTrackerType = type
      this.showUpdateWebhookDialog = true
    },
    toggleCourier(courier) {
      const data = {'enabled': this.couriers[courier].enabled}
      this.axios.patch(`/shipping/settings/${this.company.slug}/${courier}`, data)
        .then(() => {
          const shipments = {
            easyparcel: this.couriers.easyparcel.enabled,
            zepto: this.couriers.zepto.enabled,
            lalamove: this.couriers.lalamove.enabled,
            yscourier: false,
            yslocaldelivery: false
          }
          this.$store.commit('orders/setShipments', shipments)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    openCourier (courier) {
      if (courier === 'easyparcel') {
        this.$router.push('/admin/settings/easyparcel')
      } else if (courier === 'zepto') {
        this.$router.push('/admin/settings/zeptoexpress')
      } else if (courier === 'lalamove') {
        this.$router.push('/admin/settings/lalamove')
      }
    },
    getAvailability (index) {
      return this.couriers[index].available
    },
    fetchShippingSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}`).then((response) => {
        this.couriers = response.data.couriers
      },()=>{})
    },
    handleClickFromYezzaPayNoticeBanner () {
      if (this.$store.state.ui.securepayMigrateModal) {
        this.paymentExpansionPanels = 0
      }
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.paymentExpansionPanels = 0
        }
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "section_title_zone": "Manage shipping & delivery methods by zones",
    "section_desc_zone": "Manage shipping & delivery methods by zones",

    "section_title_courier": "Courier Integration",
    "section_desc_courier": "Take advantage of courier services that can easily integrated with your Yezza account",

    "section_title_ondemand": "On-Demand Delivery Integration",
    "section_desc_ondemand": "Take advantage of on-demand delivery services that can easily integrated with your Yezza account",

   
    "learn_more": " Learn More"
  },
  "id": {
    "section_title_zone": "Kelola metode pengiriman & pengiriman menurut zona",
    "section_desc_zone": "Kelola metode pengiriman & pengiriman menurut zona",

    "section_title_courier": "Integrasi Kurir",
    "section_desc_courier": "Manfaatkan layanan kurir yang dapat diintegrasikan dengan mudah dengan akun Yezza kamu",

    "section_title_ondemand": "Integrasi Pengiriman Sesuai Permintaan",
    "section_desc_ondemand": "Manfaatkan layanan pengiriman sesuai permintaan yang dapat diintegrasikan dengan mudah dengan akun Yezza kamu",

   
    "learn_more": " Pelajari Lebih Lanjut"
  }
}
</i18n>
